module.exports = __webpack_public_path__ + "./images/80267eff798d89c57da132e4a7701094.jpg";